export const url = "https://ycmc-backend.azurewebsites.net"